export const MAX_TOP_PERFORMERS = 8;
